const icon = new URL('../../icons/equipment.png', import.meta.url).href

export default {
  type: 'Scanner',
  description: 'Fixed mount barcode/QR scanner',
  group: ['etc'],
  icon,
  model: {
    type: 'Scanner',
    x1: 100,
    y1: 100,
    x2: 130,
    y2: 110,
    x3: 100,
    y3: 120,
    strokeStyle: '#333',
    fillStyle: 'red',
    lineWidth: 1
  }
}
